import { Component, Inject, OnInit, ViewEncapsulation } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { FuseConfirmationConfig } from '@fuse/services/confirmation/confirmation.types';
import { interval, take, tap } from "rxjs";

@Component({
    selector: 'fuse-confirmation-dialog',
    templateUrl: './dialog.component.html',
    styles: [
        `
            .fuse-confirmation-dialog-panel {

                @screen md {
                    @apply w-128;
                }

                .mat-mdc-dialog-container {

                    .mat-mdc-dialog-surface {
                        padding: 0 !important;
                    }
                }
            }
        `
    ],
    encapsulation: ViewEncapsulation.None
})
export class FuseConfirmationDialogComponent implements OnInit {
    /**
     * Constructor
     */
    constructor(@Inject(MAT_DIALOG_DATA) public data: FuseConfirmationConfig) {
    }

    protected waitTime: number = 0;

    protected previewMessageText: string;
    protected previewMessageButton: string;

    ngOnInit(): void {
        if (this.data.minWaitTime > 0) {
            this.waitTime = this.data.minWaitTime;
            interval(1_000)
                .pipe(
                    take(this.data.minWaitTime),
                    tap(() => {
                        this.waitTime = this.waitTime - 1;
                    })
                )
                .subscribe();
        }

        if (this.data.messagePreviewText) {
            let messageBlobs = this.data.messagePreviewText.split('|');
            this.previewMessageText = messageBlobs[0];
            this.previewMessageText = this.previewMessageText.replaceAll('*', '**');
            if (messageBlobs.length > 1) {
                this.previewMessageButton = messageBlobs[1].split(',')[0].replaceAll('[', '').replaceAll(']', '').trim();
            }
        }
    }

}
